/**
 * AH – Founder Section  |  Nasalix Shopify Theme
 * File: assets/ah-founder.js
 *
 * Static section — no storefront JS behaviour.
 * Shopify Theme Editor event handling only.
 */

(function ($) {
  'use strict';

  document.addEventListener('shopify:section:select', function (e) {
    var el = document.getElementById('ah-founder-' + e.detail.sectionId);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

})(jQuery);